module.exports = __webpack_public_path__ + "static/media/logo_business.d232c748.svg";